export interface UserState {
    INMTYP?: string
    familyname?: string,
    CUNO?: string,
    title?: string,
    phone?: string,
    givenname?: string,
    companyname?: string,
    INFLID?: string,
    email: string
}

export function extractCurrentUser(configuration:any): UserState|null {
    return configuration&&configuration.authenticated?
        {
            INMTYP: configuration.INMTYP,
            familyname: configuration.familyname,
            CUNO: configuration.CUNO,
            title: configuration.title,
            phone: configuration.phone,
            givenname: configuration.givenname,
            companyname: configuration.companyname,
            INFLID: configuration.INFLID,
            email: configuration.email
        }
        :null;
}



// WEBPACK FOOTER //
// ./src/user.ts